import React from 'react';
import './ServiceManager.css';

const ServiceManager = ({ children, visible = true }) => {
  if (!visible) {
    return null;
  }

  return <div className="service-manager-shell">{children}</div>;
};

export default ServiceManager;
